import RouteLink from '@/components/navigation/RouteLink';
import { replaceDuplicates } from '@/lib/utils';
import { useTranslation } from 'next-i18next';

export default function CompanyOffers({ company, offers }) {
	const namespace = `${company.transportType}_company`;
	const { t } = useTranslation([namespace, 'common']);

	const sectionTitle = replaceDuplicates(
		t('routes.title', { company: company.name })
	);
	const pricedOffer = offers.find((offer) => offer.price.value);

	return (
		<section id="routes" className="space-y-4">
			<h2 className="mt-2 text-xl font-bold tracking-tight text-gray-900">
				{sectionTitle}
			</h2>
			<table className="w-full text-left text-sm leading-loose text-gray-600 lg:text-base">
				<thead className="border-b border-gray-300 text-gray-700">
					<tr>
						<th className="py-2">{t('common:links.routes.title')}</th>
						<th className="hidden py-2 md:table-cell">
							{t('common:routeSummary.departure')}
						</th>
						<th className="hidden py-2 md:table-cell">
							{t('common:routeSummary.arrival')}
						</th>
						<th className="hidden py-2 md:table-cell">
							{t('common:routeSummary.duration')}
						</th>
						<th className="py-2 text-right md:text-center">
							{t('common:routeSummary.price')}
							{pricedOffer && (
								<span className="pl-2 text-xs font-normal text-gray-500">
									({pricedOffer.price.currencyCode})
								</span>
							)}
						</th>
					</tr>
				</thead>
				<tbody>
					{offers.map((offer) => (
						<tr key={offer.id} className="border-b border-gray-100">
							<td className="py-1.5 pr-1.5">
								<RouteLink
									prefetch={false}
									route={{
										origin: offer.origin,
										destination: offer.destination,
										slug: `${offer.origin.slug}-x-${offer.destination.slug}`,
										id: `${offer.origin.id}#${offer.destination.id}`,
									}}
									transportType={company.transportType}
									className="text-blue-600 hover:text-blue-900"
								/>
							</td>
							<td className="hidden py-1.5 md:table-cell">
								{offer.departureDateTime}
							</td>
							<td className="hidden py-1.5 md:table-cell">
								{offer.arrivalDateTime}
							</td>
							<td className="hidden py-1.5 md:table-cell">{offer.duration}</td>
							<td className="py-1.5 text-right md:text-center">
								<RouteLink
									prefetch={false}
									transportType={company.transportType}
									route={{
										origin: offer.origin,
										destination: offer.destination,
										slug: `${offer.origin.slug}-x-${offer.destination.slug}`,
										id: `${offer.origin.id}#${offer.destination.id}`,
									}}
									className="inline-flex  items-center rounded-full px-2.5 py-px shadow-md ring-1 ring-blue-600 hover:bg-blue-100 md:px-3.5 md:py-1"
								>
									{offer.price.value ? (
										<>
											<span className="shrink truncate pr-1 text-xs text-blue-600 lg:text-sm">
												{t('common:routeSummary.price_from')}
											</span>
											<span className="font-bold text-blue-600">
												{offer.price.currencySymbol}
												{Math.round(offer.price.value)}
											</span>
										</>
									) : (
										<span className="font-bold text-gray-900">
											{t('common:buttons.scheduleDetails')}
										</span>
									)}
								</RouteLink>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<p className="text-base text-gray-600">
				{t('routes.description', { company: company.name })}
			</p>
		</section>
	);
}
